<template>
    <div class="navForget">
        <div class="shortcut">
            <div class="inner">
                <div class="floatLeft">
                    
                    <router-link to="/login">
                        <p>登陆</p>
                    </router-link>
                    <router-link to="/register">
                        <p> 注册 </p>
                    </router-link>
                </div>
                <!-- <div class="floatRight">
                    <ul class="clearfix">
                        <li class="btn-url url-child">
                            <a href="">我的企链工</a>
                            <i class="arrow-icon"></i>
                        </li>
                        <li class="btn-url url-child">
                            <a href="">商家服务</a>
                        </li>
                        <li class="btn-url url-child"><a href="">更多应用</a></li>
                        <li class="btn-url url-child"><a href="">帮助中心</a></li>
                        <li class="btn-url"><a href="">网站导航</a></li>
                        <li class="btn-url url-child moblie-zkh"><a href="">手机企链工</a></li>
                        <li class="btn-url tel-zkh"><a href="">123-344-2342</a></li>
                    </ul>
                </div> -->
            </div>
        </div>
        <div class="logo-forget">
            <div class="logo" @click="HandleImgPage">
                <img src="../../assets/newLogo.png" alt="">
            </div>
        </div>
        <div class="inner_reg">
            <div class="n_login">
                <div class="forget-password"><p>找回手机密码</p></div>
               
                <div class="ruleFormCode" >
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="手机号码：" prop="phone">
                            <el-input v-model="ruleForm.phone" placeholder="请输入手机号" class="inputWidth"></el-input>
                        </el-form-item>
                        
                        <el-form-item label="短信验证码：" prop="phoneCode">
                            <el-input v-model="ruleForm.phoneCode" placeholder="请输入手机验证码" class="codeInput"></el-input>
                            <el-button class="codeButton" @click="HandleCode">获取验证码</el-button>
                        </el-form-item>
                   
                        <el-form-item label="请输入新密码" prop="password">
                            <el-input v-model="ruleForm.password" placeholder="请输入新密码"  type="password" class="inputWidth"></el-input>
                        </el-form-item>
                        <el-form-item label="请确认新密码" prop="newPassword">
                            <el-input v-model="ruleForm.newPassword" placeholder="请确认新密码" type="password" class="inputWidth"></el-input>
                            
                        </el-form-item>
                        
                        <el-form-item>
                            <el-button type="primary" class="restButtonForget" v-show="activeType == 1" @click="resetpwd">确认</el-button>
                        </el-form-item>
                    </el-form>

                    <div >
                        <el-result icon="success" title="密码修改成功"  v-show="activeType == 2">
                            <template slot="extra">
                                <router-link to="/login"><el-button type="primary" size="medium">返回登陆页</el-button></router-link>
                            </template>
                        </el-result>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
export default{
    data(){
        var validatePassword = (rule, value, callback) => {
            const regex = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
            if (!regex.test(value)) {
                callback(new Error('密码必须包含大小写字母'));
            } else {
                callback();
            }
        }
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.newPassword !== '') {
            this.$refs.ruleForm.validateField('newPassword');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
        return{
            activeType: 1,
            value: '',
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            ruleForm: {
                phone: '',
                code: '',
                phoneCode: '',
                newPassword: '',
                password: ''
            },
            rules: {
                phone: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    { min: 11, max: 11, message: '请正确输入手机号码', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入验证码', trigger: 'change' }
                ],
                phoneCode: [
                    {  required: true, message: '请输入手机验证码', trigger: 'change' }
                ],
                password: [
                    { required: true, message: '请输入新密码', trigger: 'blur',validator: validatePass },
                    { validator: validatePassword, trigger: 'blur' }
                ],
                newPassword: [
                    { required: true,validator: validatePass2}
                ],
            },
            rulesNew: {
                
            }
        }
       
        
    },
    methods: {
        HandleImgPage(){
            this.$router.push({
                path: '/homePage'
            })
        },
        HandleCode(val){
            // this.activeType =val  2
            let data = {
                ac: 'appvercode',
                phone: this.ruleForm.phone,
                usecate: "resetpwd",
                expireTime: '5'
            }
            this.$store.dispatch('login/sendsms',data)
                .then(res => {
                    if(res.ok){
                        console.log("ces------------------");
                        console.log(res);
                        this.$alert('发送成功', '提示',{
                            confirmButtonText: '确定',
                        })
                    }else{
                        this.$alert(res.msg,'提示',{
                            confirmButtonText: '确定'
                        })
                    }
                })

        },
        resetpwd(){
            console.log("cs");
            this.$refs.ruleForm.validate((valid) => {
                    
                if (valid) {
                    let data = {
                        user_mobile: this.ruleForm.phone,
                        smscode: this.ruleForm.phoneCode,
                        user_password: this.ruleForm.password
                    }

                    this.$store.dispatch('login/resetPwd',data)
                        .then(res => {
                            if(res.ok){
                                this.$alert('修改密码成功','提示',{
                                    cancelButtonText: '确定'
                                })
                                this.activeType = 2
                            }else{
                                this.$alert(res.msg,'提示',{
                                    cancelButtonText: '确定'
                                })
                            }
                        }).catch(err => {

                        })
                }
            })
            
        }
    }
}
</script>
<style>
.tab .el-step__head.is-finish .is-text{
    background: #7abe51;
    color: #fff;
    border: 2px solid #7abe51;
}
.tab .el-step__icon.is-text {
    background: #d7d7d7;
    color: #fff;
    border: 2px solid #d7d7d7;
}

.tab .el-step__line-inner{
    line-height: 30px;
    height: 4px;
    background: #7abe51;
    border-radius: 4px;
    border: 4px solid #7abe51;
}
.tab .el-step.is-horizontal .el-step__line{
    /* background: #7abe51; */
    margin-top: 6px;
    /* border: 2px solid; */
}
.tab .el-step.is-horizontal .el-step__line{
    height: 4px;
    border-radius: 4px;
}
.tab .el-step__title.is-finish{
    font-size: 14px;
    color: #666666;
}
.tab .el-step__title.is-process{
    font-size: 14px;
    color: #666666;
}
.tab .el-step__title.is-wait{
    font-size: 14px;
    color: #666666;
}
/* .tab .el-step__icon.is-text{
    background: #7abe51;
    color: #fff;
} */</style>
<style scoped>
.navForget{
    width: 100%;
    background: #fff;
}
.shortcut {
    width: 100%;height: 40px;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
}
.inner {
    width: 1152px;height: 40px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
   
}
.floatLeft{
    display: flex;
    justify-content: flex-start;
    color: #666666;
}
.floatLeft p{
    cursor: pointer;
    color: #000;
}
.floatLeft :nth-child(1){
    margin-right: 16px;
}
.clearfix{
    width: 616px;height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
}
.clearfix li{
    cursor: pointer;
    font-size: 13px;
}
.btn-url {
    padding: 0 15px 0 0px;
    border-right: 1px solid #666666;
    text-align: center;
    cursor: pointer;
}
.btn-url a{
    color: #2d2d34;
    font-size: 13px;
    cursor: pointer;
}
.btn-url :hover{
    height: 30px;
    color: #f74747;
}
.btn-url:last-child{
    border-right: none;
}

.tel-zkh a{
    color: #f74747;
    font-weight: bold;
}

.clearfix .btn-url .url-child .arrow-icon {
    position: absolute;
    top: 18px;
    right: 8px;
    width: 20px;
    height: 5px;
    background: url(../../assets/sprites-header.png) -5px -5px;
    transition: .2s ease-in 0s;
}

.logo-forget{
    width: 1152px;
    margin: 35px auto;
}
.logo-forget .logo{
    height: 60px;
    max-width: 224px;max-height: 60px;
    cursor: pointer;
}
.logo-forget .logo img{
    width: 200px;height: 60px;
}

.inner_reg {
    width: 1152px;
    margin: 0 auto;
    position: relative;
}

.n_login {
    width: 1150px;
    height: 510px;
    border: 1px solid #e2e2e2;
    background: #fff;
    padding: 0;
}
/* .n_login {
    float: left;
    border: 1px #e2e2e2 solid;
    border-top: 2px solid #f74747;
    width: 1152px;
    padding: 5px 75px 20px;
    margin: 5px 0;
    font-size: 14px;
    box-sizing: border-box;
} */
.forget-password p{
    line-height: 14px;
    margin-left: 38px;
    margin-top: 16px;
    font-size: 14px;
    color: #666666;
}
.tab{
    width: 800px;height: 64px;
    margin: 30px auto;
    /* display: flex; */
}
.ruleFormCode{
    width: 500px;
    margin: 60px auto;
}



.ruleFormCode .img{
    width: 123px;height: 39px;
    float: right;
    margin-right: 13px;
    border: 1px solid #e5e5e5;
}
.ruleFormCode span{
    float: right;
    cursor: pointer;
    color: #666666;
    font-size: 12px;
}
.ruleFormCode span:hover{
    float: right;
    cursor: pointer;
    color: #f74747;
}
@media screen and (min-width: 541px) {
    .ruleFormCode .el-input{
        width: 188px;height: 42px;
    }
    .ruleFormCode .inputWidth{
        width: 332px;height: 42px;
    }
    .restButtonForget{
        width: 332px;height: 40px;
        background: #4095e5;
        color: #ffffff;
        border: 1px solid #4095e5;
        margin-top: 20px;
        align-items: center;
    }
    .codeButton{
        width: 125px;height: 42px;
        margin-left: 20px;
        background: #f2f2f2;
    }
}
@media screen and (max-width: 540px) {
   
    .shortcut {
        width: 100%;height: 40px;
        border-bottom: 1px solid #e5e5e5;
        position: relative;
    }
    .inner {
        width: 95%; 
    }
    
    .logo-forget{
        width: 95%;margin-top: 20px;
    }
    .logo-forget .logo img{
        width: 180px;height: 55px;
    }
    
    .inner_reg {
        width: 95%;
        margin: 0 auto;
        position: relative;
    }

    .n_login {
        width: 100%;height: 450px;
        margin-top: -20px;
    }
   
    .forget-password p{
        margin-left: 10px;
    }
   
    .ruleFormCode{
        width: 100%;
    }
    .ruleFormCode .codeInput{
        width: 45%;
        height: 42px;
    }
    .ruleFormCode .inputWidth{
        width: 95%;height: 42px;
    }
    .restButtonForget{
        width: 95%;height: 40px;
        background: #4095e5;
        color: #ffffff;
        border: 1px solid #4095e5;
        margin-top: 20px;
        align-items: center;
    }
    .codeButton{
        width: 45%;height: 42px;
        margin-left: 10px;
        background: #f2f2f2;
    }
    .ruleFormCode .img{
        width: 123px;height: 39px;
        float: right;
        margin-right: 13px;
        border: 1px solid #e5e5e5;
    }
    .ruleFormCode span{
        float: right;
        cursor: pointer;
        color: #666666;
        font-size: 12px;
    }
    .ruleFormCode span:hover{
        float: right;
        cursor: pointer;
        color: #f74747;
    }
}
</style>